import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, onChildAdded, onChildRemoved, off, remove } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import RowEdit from '../modules/RowEditMode'
import './Edit.css'

class EditMode extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rows: []
    }
    this.rows = []
    this.handleDelete = this.handleDelete.bind(this)
    this.dbRef = ref(database, 'quinielas')
  }
  componentDidMount () {
    const indexRef = child(this.dbRef, 'index/' + this.props.match.params.mode)
    onChildAdded(indexRef, (snap) => {
      this.rows.push({
        id: snap.key,
        fecha: snap.val().fecha,
        actual: snap.val().current,
        activa: snap.val().active,
        desde: snap.val().desde,
        modalidad: this.props.match.params.mode
      })
      this.rows.sort((a, b) => {
        if (a.desde < b.desde) {
          return 1
        }
        if (a.desde > b.desde) {
          return -1
        }
        return 0
      })
      this.setState({
        rows: this.rows
      })
    })
    onChildRemoved(indexRef, (snap) => {
      this.rows = this.rows.filter((row) => row.id !== snap.key)
      this.setState({
        rows: this.rows
      })
    })
  }
  componentWillUnmount () {
    const indexRef = child(this.dbRef, 'index/' + this.props.match.params.mode)
    off(indexRef)
  }
  handleDelete (ev, id) {
    ev.preventDefault()
    remove(child(this.dbRef, 'index/' + this.props.match.params.mode + '/' + id))
    remove(child(this.dbRef, 'partidos/' + this.props.match.params.mode + '/' + id))
    remove(child(this.dbRef, 'resultados/' + this.props.match.params.mode + '/' + id))
  }
  render () {
    return (
      <div className='edit'>
        <Title title='Administrar quiniela' />
        <div className='edit__content'>
          <div className='edit__content__header'>
            <h3>Administra una quiniela</h3>
          </div>
          <div className='edit__content__body'>
            {this.state.rows.map((row) => (
              <RowEdit
                {...row}
                key={row.id}
                handleDelete={this.handleDelete}
                history={this.props.history}
              />))}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(EditMode)
